import React, { useContext } from "react";
import { EGKanbanContext } from "../Context/EGKanbanContext";
import { SearchInput } from "../../widgets";

const SearchFilter = () => {
    const context = useContext(EGKanbanContext);

    return <SearchInput
        onChange={searchText => {
            context.searchText = searchText;
            context.eventEmitter.emit("@kanban/change_searchtext", searchText);
        }} />;
};

export default SearchFilter;